import { Pipe, PipeTransform } from '@angular/core';

import { IFullName } from '../models';
import { mapToFullCapitalizedNameString, mapToFullNameString } from '../functions';


@Pipe({
	name: 'fullName',
	standalone: true
})

export class FullNamePipe implements PipeTransform {
	transform(fullName: IFullName, capitalize = true): string {
		if (!fullName) return ''
		return capitalize ? mapToFullCapitalizedNameString(fullName) : mapToFullNameString(fullName);
	}
}
